// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"8479d6ec","150":"43adb07d","200":"df028d3c","390":"adc0ee7f","575":"ce5430cc","682":"6d10e95d","864":"02df3206","902":"8fce473f","915":"a61dd1aa","943":"aa721b92"}[chunkId] + ".chunk.js";
};